var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tl-loading"},[_vm._v("\n  Loading...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }